import { async } from '@firebase/util'
import { Button, ButtonBase } from '@mui/material'
import { deleteDoc, doc } from 'firebase/firestore'
import React, { forwardRef } from 'react'
import db, { auth } from './firebase'
import { Avatar } from "@mui/material"
import "./Post.css"



const Post =forwardRef(
  ({displayName,key,author,uesrName,verified,id,aid,text,image,avatar,price,ref}:any)=> {
    const handleDelete = async()=>{
      await deleteDoc(doc(db,"posts",id))
    }
    return (
      <div className='post' ref={ref}>
          <div className='post--avatar'>
           <Avatar src={avatar}/>
          </div>
          <div className='post--body'>
              <div className='post--header'>
                  <div className='post--headerText'>
                      <h3>
                        {displayName}
                      <span className='post--headerSpecial'>
                         @{price}
                      </span>
                      </h3>
                  </div>
                  <div className='post--headerDescription'>
                      <p>{text}</p>
                  </div>
              </div>
              <img src={image}/>
              <div className='post--footer'>
                <Button onClick={()=>{
                  window.scrollTo({
                  top:0,
                  behavior:"smooth"
                  }) }}>
                    top
                </Button>
                {aid===auth.currentUser?.uid&&(
                  <>
                  <Button onClick={()=>handleDelete()}>delete</Button>
                  </>
                )}
              </div>
          </div>
      </div>
    )
  }
)


export default Post